import { Feature } from "ol";
import { estiloMarcadorLocation } from "../../store/map/estilos";

export const crearMarcador = (map) => {
  const ft = new Feature();
  ft.setStyle(estiloMarcadorLocation);
  map.utils.getSource().addFeature(ft);
  return ft;
};
